import { Container } from "@mantine/core"
import { Outlet } from "react-router-dom"

import { PageHeader } from "../../layout/PageLayout/PageHeader"

export type PageLink = {
  label: string
  link: string
  wip?: boolean
  tooltip?: string
}

type Props<T> = {
  title: string
  pages?: PageLink[]
  data?: T
  canGoBack?: boolean
  mainCta?: React.ReactNode
  children?: React.ReactNode
}

export const Page = <T,>({
  title,
  pages,
  data,
  canGoBack = false,
  mainCta,
  children,
}: Props<T>) => {
  return (
    <Container
      fluid
      py="var(--tfg-layout-padding-y)"
      px="var(--tfg-layout-padding-x)"
      mb="var(--tfg-layout-padding-y)"
      style={{
        height: "calc(100vh)",
        overflow: "auto",
      }}
    >
      <PageHeader
        title={title}
        pages={pages}
        canGoBack={canGoBack}
        mainCta={mainCta}
      />
      <Container fluid p={0} py="var(--tfg-layout-padding-y)">
        {children || <Outlet context={data} />}
      </Container>
    </Container>
  )
}
